
import { supabase } from '../../supabase';
import { TimeStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get time distribution statistics (hour of day)
 */
export const getTimeStats = async (
  startDate: Date, 
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<TimeStat[]> => {
  const { data, error } = await supabase.rpc('get_time_stats_aggregated', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });
  
  if (error) {
    console.error('Error fetching time stats:', error);
    throw error;
  }
  
  // Initialize all hours with 0 counts for UI continuity
  const hourCounts: Record<number, number> = {};
  for (let i = 0; i < 24; i++) {
    hourCounts[i] = 0;
  }
  
  // Merge database results
  (data || []).forEach(item => {
    hourCounts[item.hour] = Number(item.count);
  });
  
  return Object.entries(hourCounts).map(([hour, count]) => ({
    hour: parseInt(hour),
    count
  })).sort((a, b) => a.hour - b.hour);
};
